import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { interval, Observable, Subscription } from 'rxjs';
import { TASK_POLLING_INTERVAL } from '../conf/tasks';

import { AppState } from '../store/app.reducer';
import * as TaskActions from 'src/app/store/task/task.actions';
import { Device, supportTasks } from '../model/device';
import { selectActiveTask } from '../store/task/task.selector';
import { Task } from '../model/tasks';

@Injectable({
    providedIn: 'root'
})
export class TasksPollingService {
    sub: Subscription;

    activeTasks$: Observable<Task[] | undefined>;
    activeTasksSub: Subscription | undefined;

    constructor(
        private store: Store<AppState>,
    ) {
        this.initSelectors();
    }


    initSelectors(): void {
        this.activeTasks$ = this.store.select(selectActiveTask);
    }

    fetchActiveTask(device: Device): void {
        this.store.dispatch(TaskActions.resetActiveTasks());
        if (supportTasks(device)) {
            this.store.dispatch(TaskActions.getActiveTasks({}));
        }
        this.activeTasksSub = this.activeTasks$.subscribe(activeTasks => {
            if (activeTasks.length > 0) {
                this.startPolling(device);
                this.activeTasksSub?.unsubscribe();
            }
        });
    }

    startPolling(device: Device): void {
        if (this.sub) {
            this.sub?.unsubscribe();
        }
        if (supportTasks(device)) {
            this.sub = interval(TASK_POLLING_INTERVAL).subscribe(() => {
                this.store.dispatch(TaskActions.getActiveTasks({}));
            });
        }
    }

    stopPollingExit(): void {
        this.sub?.unsubscribe();
        this.activeTasksSub?.unsubscribe();
    }

    stopPollingWsc(): void {
        this.activeTasksSub = this.activeTasks$.subscribe(activeTasks => {
            if (activeTasks.length === 0) {
                this.sub?.unsubscribe();
                this.activeTasksSub?.unsubscribe();
            }
        });
    }
}
